import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from './authService';
import './css/LoginRegForm.css';
import logo from './images/QLmaterials1.png';
import pdfFile from './images/QL_PP.pdf';


const LogRegForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [agreeToPolicy, setAgreeToPolicy] = useState(false);
    const [messages, setMessages] = useState([]);
    const [activeTab, setActiveTab] = useState('register');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();


    const handleRegister = (e) => {
        e.preventDefault();

        // Email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            setMessages(["Invalid email format"]);
            setError(true);
            return;
        }

        // Password length validation
        if (password.length < 5) {
            setMessages(["Password must be at least 5 characters long"]);
            setError(true);
            return;
        }

        if (!agreeToPolicy) {
            setIsSubmitted(true);
            return;
        }

        authService.register(email, password)
        .then((response) => {
            // Success! Redirect to login and pass the state to trigger the modal
            navigate('/login', { 
                state: { 
                    showVerificationModal: true,
                    registeredEmail: email // Optional: if you want to pre-fill the login email
                } 
            });
        })
        .catch((error) => {
            // Handle specific backend errors (e.g., email already exists)
            const errorMsg = error.response?.data?.detail || "Registration failed. Please try again.";
            setMessages([errorMsg]);
            setError(true);
        });
    };


    const doNothing = (e) => {
        e.preventDefault();
    };


    const handleTabClick = (tab) => {
        setActiveTab(tab);
      };

    return (
        <div className='logreg-back'>
            <div className="box-con">
                <div className="box">
                    <div className="upper-part">
                        <img className="logo" src={logo} alt="logo" />
                    </div>
                    <div className="tab-container">
                        <div className='borders-left'></div>
                        <div className='borders-right'></div>
                        <Link
                            id="login-link"
                            to="/login"
                            className={`tab ${activeTab === 'login' ? '' : 'left-disp inactive-tab'}`}
                            onClick={() => handleTabClick('login')}>
                            Log in
                        </Link>
                        <Link
                            to="/register"
                            className={`tab ${activeTab === 'register' ? 'right-tab' : ''}`}
                            onClick={() => handleTabClick('register')}>
                            Sign up
                        </Link>

                    </div>
                    <form className="form">
                        <div className='form-wrapper'>
                            <div className="message-group"
                            style={{ backgroundColor: error ? 'rgb(221, 167, 164)' : 'transparent' }}>
                                <p id="messages" className="message">{messages}</p>
                            </div>
                            
                            <div className="form-group form-first">
                                <div className="svg-div">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                                        <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
                                    </svg>
                                </div>
                                <div className="username-form">
                                    <input type="email" name="username" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                </div>
                            </div>
                            <div className="form-group form-last">
                                <div className="svg-div">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-lock-fill" viewBox="0 0 16 16">
                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2"/>
                                    </svg>
                                </div>
                                <div className="email-form">
                                    <input type="password" name="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                </div>
                            </div>
                            <div className="forgot" 
                            style={{ backgroundColor: isSubmitted ? 'rgba(200, 31, 31, .26)' : 'transparent' }}>
                                <input type="checkbox" id="agreeToPolicy" checked={agreeToPolicy} onChange={(e) => setAgreeToPolicy(e.target.checked)} />
                                <span className="custom-checkbox"></span>
                                <label
                                    htmlFor="agreeToPolicy"
                                    style={{ color: isSubmitted ? 'rgb(159, 97, 121)' : 'rgb(166, 166, 166)' }}
                                    >
                                    I agree to the{' '}
                                    <a
                                        href={pdfFile}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="privacy-policy-link"
                                    >
                                        privacy policy.
                                    </a>
                                </label>

                            </div>
                        </div>
                        <div>
                            <div className='button-wrap'>
                                <button onClick={handleRegister} className="login-but">REGISTER</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LogRegForm;
